<template>
  <svg id="verlichting" viewBox="15 0 50 50">
    <g transform="translate(10,0)">
      <path
        d="M25.449,7.42l3.772,1.16l-11.629,3.351l-0.294,0.085c-0.505,0.146-0.797,0.674-0.652,1.18
                            c0.12,0.418,0.502,0.69,0.916,0.69c0.087,0,0.176-0.013,0.264-0.038l15-4.323c0.405-0.117,0.686-0.485,0.689-0.908
                            c0.003-0.421-0.271-0.796-0.673-0.919l-7.104-2.184c-0.177-0.054-0.367-0.056-0.544-0.005l-7.771,2.238
                            c-0.507,0.146-0.799,0.674-0.653,1.18c0.118,0.408,0.487,0.664,0.889,0.677c0.097,0.002,0.194,0.004,0.291-0.025L25.449,7.42z"
      />
      <path
        d="M17.562,18.706c0.087,0,0.176-0.012,0.265-0.037l14.999-4.323c0.507-0.146,0.799-0.675,0.652-1.181
                            s-0.674-0.796-1.181-0.652l-15,4.323c-0.505,0.146-0.797,0.674-0.652,1.181C16.767,18.435,17.148,18.706,17.562,18.706"
      />
      <path
        d="M17.562,24.136c0.087,0,0.176-0.013,0.265-0.038l14.999-4.322c0.507-0.146,0.799-0.675,0.652-1.181
                            s-0.674-0.797-1.181-0.652l-15,4.323c-0.505,0.146-0.797,0.674-0.652,1.18C16.767,23.864,17.148,24.136,17.562,24.136"
      />
      <path
        d="M32.826,27.695l-3.046-0.878l-1.273-0.367l2.456-0.708l1.863-0.537c0.507-0.146,0.799-0.674,0.652-1.18
                            c-0.146-0.506-0.674-0.798-1.181-0.652l-15,4.322c-0.332,0.097-0.587,0.365-0.664,0.702c-0.078,0.338,0.033,0.69,0.29,0.923
                            l3.653,3.298h-2.029v5.904c0,1.22,0.913,2.218,2.089,2.376c0.845,1.593,2.5,2.692,4.425,2.692c1.924,0,3.581-1.1,4.424-2.692
                            c1.177-0.157,2.09-1.156,2.09-2.376v-5.904h-2.028l3.653-3.298c0.257-0.232,0.367-0.585,0.29-0.923
                            C33.413,28.061,33.158,27.792,32.826,27.695 M25.062,41.877c-0.899,0-1.713-0.361-2.31-0.946h4.621
                            C26.775,41.516,25.961,41.877,25.062,41.877 M29.862,38.522c0,0.384-0.312,0.695-0.694,0.695h-8.211
                            c-0.383,0-0.694-0.312-0.694-0.695v-0.891h9.599V38.522z M29.862,35.918h-9.599v-1.586h9.599V35.918z M27.116,32.244l-0.332,0.3
                            c-0.023,0.021-0.033,0.051-0.055,0.074h-3.333h-0.002c-0.021-0.023-0.031-0.053-0.055-0.074l-3.866-3.491l5.602-1.614
                            c0.013,0.005,0.022,0.015,0.035,0.019l5.539,1.596L27.116,32.244z"
      />

      <g transform="scale(0.3) translate(105,100)">
        <IconKruisAppendix />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import IconKruisAppendix from '@/components/icon/custom/templates/IconKruisAppendix.vue';

@Component({ components: { IconKruisAppendix } })
export default class IconVerlichtingKruis extends Vue {}
</script>
